module.exports = __webpack_public_path__ + "87d1b506325dcbf4a60aeb0c24b75040.pdf";